import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { TestTypesContainerState } from './testtypes';

const initialState: TestTypesContainerState = {
  default: 'default',
};

export const slice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setDefault: (state, action: PayloadAction<string>) => {
      state.default = action.payload;
    },
  },
});

export const {
  setDefault,
} = slice.actions;

export default slice.reducer;
